//scopes

const scopes = {
  masterTables: "masterTables",
  icdCodes: "icdCodes",
  therapies: "therapies",
  locations: "locations",
  businesses: "businesses",
};

export const masterTablesKeys = {
  therapyColors: {
    scope: scopes.masterTables,
    all: () => [scopes.masterTables, "therapyColors"] as const,
  },
  masterTables: {
    scope: scopes.masterTables,
    all: () => [scopes.masterTables] as const,
  },
  prescribedTherapyOptions: {
    scope: scopes.masterTables,
    all: () => [scopes.masterTables, "prescribedTherapyOptions"] as const,
  },
  
  icdCodes: {
    scope: scopes.icdCodes,
    all: () => [scopes.icdCodes] as const,
    detail: (text: string) => [scopes.icdCodes, { text }] as const,
  },
  therapies: {
    scope: scopes.therapies,
    all: () => [scopes.therapies] as const,
  },
  locations: {
    scope: scopes.locations,
    all: () => [scopes.locations] as const,
    forBusiness: (businessId: string) => [scopes.locations, { businessId }] as const,
  },
  businesses: {
    scope: scopes.businesses,
    all: () => [scopes.businesses] as const,
  },
};
